import React from "react";

export const PitchEng = () => {
  return (
    <div className="pitch-section">
      <h1>MOKA ENGLISH PITCH</h1>
      <p>
        MokaToken – a game-changing solution
        for coffee shops to redefine the payment experience. Imagine offering
        your customers the ease of paying with MokaTokens, where convenience
        meets innovation. MokaToken provides two seamless pathways to embrace
        this evolution.
      </p>
      <p>
        First, through our web3 integration, customers purchase
        MokaTokens effortlessly using their cryptocurrency wallets. This
        positions your coffee shop as a tech-savvy destination and attracts
        cryptocurrency enthusiasts. For those new to crypto, our user-friendly
        web app allows customers to log in with their email. A dedicated wallet
        address is generated for them, and they can fund it through traditional
        bank deposits. These funds are then converted into MokaTokens for
        purchasing, blending traditional finance with the crypto world.
      </p>
      <p>
        MokaToken isn't just about payments – it's about enhancing experiences.
        Customers can buy tokens for themselves or as delightful gifts. Coffee
        shop owners gain real-time insights into usage patterns, refining
        offerings based on customer preferences. By offering MokaToken, your
        coffee shop becomes a trendsetter, embracing innovation and convenience.
        In a world where customers value both, MokaToken sets you apart. Join us
        in shaping the future of payments. Invest in MokaToken today, and let's
        transform your coffee shop into a hub of seamless transactions.
      </p>
      <p>
        Thank you
      </p>
    </div>
  );
};
